// Component Name:  Manage Access component
// Author: Lavanya S
// Platform: Web
// OS: Windows
// IDE: Visual Studio Code
// Date: 08-07-2025
// Reference: AddUser
// Description: This is a create new access and revoke access Modal component.
// Interfaces: Accepts props
// Maintenance History:  1.0 - First Version

import React, { useEffect, useState } from "react";
import { Row, Col, Input, Label, ModalHeader, ModalBody, UncontrolledTooltip, ModalFooter, Button, FormGroup, Table, Spinner } from "reactstrap";
import { Link } from "react-router-dom";
import ReactModal from "react-modal";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { createUser } from "../../api/userAPI";
import { connect } from "react-redux";
import { successToast, warningToast } from "../../store/dbFilter/actions";
import { modalStyle } from "../Utility/styleComponents";
import useIsMounted from "../Utility/useIsMounted";
import LKEditContentImg from "../../assets/images/LK_Icons/LK__Edit Content.svg";
import LKWhiteEditContentImg from "../../assets/images/LK_Icons/LK_white_Edit Content.svg";
import LKDeleteImg from "../../assets/images/LK_Icons/LK_Delete.svg";
import LKWhiteDeleteImg from "../../assets/images/LK_Icons/LK_White_Delete.svg";
import LKCloseImg from "../../assets/images/LK_Icons/LK_Close.svg";
import { ActiveBtn, CancelBtn, InActiveBtn } from "../Utility/Button";
import { inputRequired } from "../Utility/utilsFunctions";
import { MDBDataTable } from "mdbreact";
import { hostRegister } from "../../api/authAPI";
import { loadHost } from "../../api/utils/loadHost";
/**
 * Adduser Modal Component
 * Uses ReactModal and supports Redux-based warning/success messages.
 *
 * @param {Object} userData - name,email,phoneNumber,rfids,payType.
 * @param {boolean} isModalOpen - to toggle modal open and close.
 * @param {Function} closeModal - Callback function to perform any operation on click closeModal.
 */
const ManageAccess = (props) => {
  // handle form changes
  const [isLoading, setIsLoading] = useState(false);
  const techdata = [
    {
      name: "Anvith",
      phoneNumber: "7845127845",
      email: "anvith@indigoquotient.com",
      role: "Admin",
      // isRevoked: true,
    },
    {
      name: "Bharath",
      phoneNumber: "7845127845",
      email: "bharath@indigoquotient.com",
      role: "Admin",
      // isRevoked: false,
    },
  ];
  const [data, setData] = useState();
  const [customerData, setCustomerData] = useState({
    name: "",
    phoneNumber: "",
    email: "",
    role: "Technician",
  });
  const [isCreateAccess, setIsCreateAccess] = useState(false);
  useEffect(() => {
    if (data?.length === 0) {
      setIsCreateAccess(true);
    }
  }, []);
  //   to handle the name,email and phoneNumber change
  const handleFormChange = (e) => {
    const { name, value } = e.target;
    setCustomerData({
      ...customerData,
      [name]: value,
    });
  };

  // reset all the data before closing the modal
  const closeAddUser = (isUpdated = false) => {
    setCustomerData({
      name: "",
      phoneNumber: "",
      email: "",
      role: "Technician",
    });
    // setRfid([{ idTag: "" }]);
    // setPaymentType("Prepaid");
    // props.closeModal(isUpdated);
    setIsCreateAccess(false);
  };

  const closeModal = () => {
    props.closeModal();
  };

  /**
   * Makes a call to create a new User or update the existing one
   * returns User data on success , fetch all the user and update the table and reset state variables
   * on failure shows err message
   */
  const handleCreateUser = async () => {
    setIsCreateAccess(false);
    try {
      // let pinCodeValidated = true;
      // if (host?.pincode?.length > 0) {
      //   const flag = await validatePin();
      //   pinCodeValidated = flag;

      //   console.log("pinCodeValidate", flag);
      // }
      // if (pinCodeValidated) {
      // const address = `${host?.address}, ${addressData?.city},  ${addressData?.state}, ${addressData?.country}, ${addressData?.pincode}`;
      const techDetails = { ...customerData, role: "Tech", type: "OTH", parentId: props?.email };
      console.log("techDetails: ", techDetails);
      await hostRegister(techDetails);
      // resetHostData();
      closeAddUser();
      // } else {
      //   props.warningToast({ title: "Validation", message: "Enter Valid PinCode" });
      // }
    } catch (err) {
      console.log("Error creating/updating chargers: ", err.msg);
    }
    // if payment type is post paid, validate RFID's
    // if (paymentType === "Postpaid") {
    //   const allValidRFIDs = rfid.every((item) => /^[a-zA-Z0-9]{16}$/.test(item.idTag));
    //   if (!allValidRFIDs) {
    //     props.warningToast({ title: "Invalid RFID", message: "All RFIDs must be 16-character alphanumeric strings" });
    //     return;
    //   }
    // } else {
    //   setRfid(() => {
    //     return [];
    //   });
    // }
    // try {
    //   const response = await createUser({ ...customerData, rfids: rfid });
    //   console.log("response: ", response);
    //   const { message, data } = response;
    //   props.successToast({ title: "Success", message: message });
    //   closeAddUserModal(true);
    // } catch (err) {
    //   console.log("Error creating User:", err.msg);
    // }
  };
  useEffect(() => {
    handleLoadHost();
  }, []);

  const handleLoadHost = async () => {
    try {
      setIsLoading(true);
      const techData = await loadHost(props?.hostIds, false);
      console.log("techData: ",techData);
      
      const techRowDetails = techData?.map((item, index) => {
        const { name, email, phoneNumber, role } = item;
        const isRevoked = true;
        return {
          name: name,
          email: email,
          phno: phoneNumber,
          role: role,
          revoke: (
            <div className="d-flex align-items-center justify-content-center">
              {isRevoked ? <CancelBtn name={"Revoked"} handleClick={() => {}} customWidth={"100px"} /> : <ActiveBtn name={"Revoke"} handleClick={() => {}} customWidth={"100px"} />}
            </div>
          ),
        };
      });
      setData(techRowDetails);
    } catch (e) {
      console.log("Error Images Data: ", e);
    } finally {
      setIsLoading(false);
    }
  };
  const tableData = {
    columns: [
      { label: "Name", field: "name", sort: "asc", width: 78 },
      { label: "Email", field: "email", sort: "asc", width: 28 },
      { label: "Phone Number", field: "phno", sort: "asc", width: 93 },
      { label: "Role", field: "role", sort: "asc", width: 109 },
      { label: "Revoke Access", field: "revoke", sort: "asc", width: 90 },
    ],
    rows: data,
  };
  var modalWidth = props.layoutType === "vertical" ? "70%" : "95%";
  var modalHeight = props.layoutType === "vertical" ? "78%" : "85%";
  return (
    <ReactModal isOpen={props.isModalOpen} onRequestClose={closeModal} style={modalStyle(modalWidth, modalHeight)}>
      {/* <ModalHeader toggle={closeAddUserModal}>Customer Details</ModalHeader> */}
      <div className="d-flex justify-content-between align-items-center  mt-2 pb-3 border-bottom">
        <h5 className="m-0">{"Manage Access"}</h5>
        <img src={LKCloseImg} alt="Close" onClick={props.closeModal} style={{ cursor: "pointer", width: "20px", height: "20px", marginLeft: "auto" }} />
      </div>
      <ModalBody>
        <div className="mb-3 ml-0">
          <ActiveBtn name={"Create Access"} handleClick={() => setIsCreateAccess(true)} />
        </div>
        {isCreateAccess && (
          <AvForm className="px-3" onValidSubmit={handleCreateUser}>
            <Row>
              <Col lg={6}>
                <FormGroup>
                  <Label htmlFor="name">Name{inputRequired()}</Label>
                  <AvField name="name" type="text" className="form-control" id="name" placeholder="Enter Name" required value={customerData?.name} onChange={handleFormChange} />
                </FormGroup>
              </Col>
              <Col lg={6}>
                <FormGroup>
                  <Label htmlFor="role">Role{inputRequired()}</Label>
                  <AvField
                    name="role"
                    type="text"
                    className="form-control text-muted"
                    id="role"
                    placeholder="Enter Role"
                    value={customerData.role}
                    required
                    disabled
                    style={{ cursor: "not-allowed" }}
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col lg={6}>
                <FormGroup>
                  <Label htmlFor="email">Email{inputRequired()}</Label>
                  <AvField
                    name="email"
                    type="email"
                    className="form-control"
                    id="email"
                    placeholder="Enter Email"
                    required
                    value={customerData?.email}
                    onChange={handleFormChange}
                  />
                </FormGroup>
              </Col>
              <Col lg={6}>
                <FormGroup>
                  <Label htmlFor="phoneNumber">Phone Number</Label>
                  <AvField
                    name="phoneNumber"
                    type="text"
                    className="form-control"
                    id="phoneNumber"
                    placeholder="Enter Phone Number"
                    required
                    value={customerData?.phoneNumber}
                    onChange={handleFormChange}
                    validate={{
                      required: { value: true, errorMessage: "This field is required" },
                      pattern: {
                        value: /^[0-9]{10}$/,
                        errorMessage: "Must be exact 10 digits ",
                      },
                    }}
                  />
                </FormGroup>
              </Col>
            </Row>

            <ModalFooter className={` ${props.layoutType === "vertical" ? "" : "d-flex flex-column justify-content-center align-items-center border-bottom"}`}>
              {/* <Button type="button" color="light" onClick={closeAddUserModal}>
              Cancel
            </Button> */}
              <div className="mb-2">
                <CancelBtn name="Cancel" handleClick={closeAddUser} />
              </div>
              {/* <Button type="submit" color="primary">
              Save
            </Button> */}
              <div className="mb-2">
                <ActiveBtn name="Save" handleClick={() => {}} />
              </div>
            </ModalFooter>
          </AvForm>
        )}
        {/* <div className="table-responsive mt-3">
          <Table
            className="table-centered datatable dt-responsive nowrap "
            style={{
              borderCollapse: "collapse",
              borderSpacing: 0,
              width: "100%",
            }}
          >
            <thead className="thead-light">
              <tr>
                <th>User</th>
                <th>Email</th>
                <th>Phone</th>
                <th>Role</th>
                <th style={{ width: "120px" }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <tr>
                  <td colSpan={7} style={{ height: "250px", textAlign: "center" }}>
                    <Spinner />
                  </td>
                </tr>
              ) : data?.length === 0 ? (
                <tr>
                  <td colSpan={7} style={{ textAlign: "center" }}>
                    <h4> There are no users</h4>
                  </td>
                </tr>
              ) : (
                data?.map((customerData, key) => (
                  <tr key={key}>
                    <td>{customerData.name}</td>
                    <td>{customerData.email}</td>
                    <td>{customerData.phoneNumber}</td>
                    <td>{customerData.role}</td>

                    <td>
                      <Link
                        to="#"
                        className="mr-3 text-primary"
                        id={"edit" + key}
                        onClick={async () => {
                        
                        }}
                      >
                      </Link>
                      <UncontrolledTooltip target={"edit" + key} placement="top">
                        Edit
                      </UncontrolledTooltip>
                      <Link to="#" className="text-danger" id={"delete" + key} onClick={() => {}}>
                     
                      </Link>
                      <UncontrolledTooltip target={"delete" + key} placement="top">
                        Delete
                      </UncontrolledTooltip>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        </div> */}

        {isLoading ? (
          <div style={{ width: "100%", height: "250px" }}>
            <Spinner />
          </div>
        ) : (
           <MDBDataTable responsive paging={false} data={tableData} style={{ textAlign: "center" }} className="mt-4" />
        )}
      </ModalBody>
    </ReactModal>
  );
};
const mapStateToProps = (state) => ({
  layoutType: state.Layout.layoutType,
  email: state?.Login?.user?.email,
  hostIds: state?.HostTechManagement?.hostIds,
});

const mapDispatchToProps = (dispatch) => ({
  successToast: (payload) => dispatch(successToast(payload)),
  warningToast: (payload) => dispatch(warningToast(payload)),
});
export default connect(mapStateToProps, mapDispatchToProps)(ManageAccess);
